import {
  GET_SERVER_AUDIT_TRAIL_PENDING,
  GET_SERVER_AUDIT_TRAIL_SUCCESS,
  GET_SERVER_AUDIT_TRAIL_ERROR,
  RESET_GET_SERVER_AUDIT_TRAIL,
  GetServerAuditTrailState,
  GetServerAuditTrailActionType,
} from "./types";

const initialState: GetServerAuditTrailState = {
  getServerAuditTrailPending: false,
  getServerAuditTrailError: false,
  serverAuditTrailResponse: null
}

export function GetServerAuditTrailReducer(
  state: GetServerAuditTrailState = initialState,
  action: GetServerAuditTrailActionType
): GetServerAuditTrailState {
  switch (action.type) {

    case GET_SERVER_AUDIT_TRAIL_PENDING: {
      return {
        ...state,
        getServerAuditTrailPending: true,
      };
    }

    case GET_SERVER_AUDIT_TRAIL_SUCCESS: {
      const { payload } = action;
      const { response } = payload;

      return {
        ...state,
        getServerAuditTrailPending: false,
        getServerAuditTrailError: false,
        serverAuditTrailResponse: response
      };
    }

    case GET_SERVER_AUDIT_TRAIL_ERROR: {
      return {
        ...state,
        getServerAuditTrailPending: false,
        getServerAuditTrailError: true,
      };
    }

    case RESET_GET_SERVER_AUDIT_TRAIL: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
